import React, { useState } from 'react';
import {
  Button,
  Col,
  Form,
  Input,
  Row,
  Typography,
  Select,
  InputNumber,
  Divider,
  Space
} from 'antd';
import '../Common/Form.css';
import {
  renderAdditionalExerciseForm,
  renderAdditionalVideoForm,
  renderAdditionalCertificateForm
} from './SubunitHelpers';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';

const { Text } = Typography;

const SubunitAssetForm = ({
  initialValues,
  onSubmit,
  subunitType,
  status,
  type,
  setStatus
}) => {
  return (
    <div className="course-add-form">
      <Form
        labelCol={{ span: 10 }}
        onFinish={onSubmit}
        initialValues={initialValues}>
        {type === 'Update' ? (
          <>
            <section>
              {subunitType === 'Exercise' &&
                renderAdditionalExerciseForm()}
            </section>
            <section>
              {subunitType === 'Video' && renderAdditionalVideoForm()}
            </section>
            <section>
              {subunitType === 'Certificate' &&
                renderAdditionalCertificateForm(type)}
            </section>
          </>
        ) : null}
        {status.type === 'ERROR' ? (
          <Text type="danger">{status.message}</Text>
        ) : null}
        {status.type === 'SUCCESS' ? (
          <Text type="success">Successful!</Text>
        ) : null}
        <Row justify="end" gutter={12}>
          <Col>
            <Button type="primary" htmlType="submit">
              {type}
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default SubunitAssetForm;
